// extracted by mini-css-extract-plugin
export default {"body":"About_body__xzSHL","abt_text":"About_abt_text__jcGDJ","abt_head":"About_abt_head__u79NK","abt_word":"About_abt_word__DbKKx","abt_img":"About_abt_img__ucs2U"};